// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { stepperStyles } from "@rpsc/App/Widgets/Stepper/Stepper";
import { fontConfig } from "@rpsc/XDL/PreStyle/typography";
import { color } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

stepperStyles.container = {
    css: css`
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
    `,
};

stepperStyles.stepWrapper = {
    css: css`
        display: flex;
        flex: 1;
        align-items: center;
        justify-content: center;
        height: 0;
        position: relative;

        &.incomplete {
            border: 5px solid ${color("common.ui3")};
            opacity: 0.5;
            pointer-events: none;
        }
        &.active,
        &.complete {
            border: 5px solid ${color("primary.main")};
        }

        &:first-child {
            border-radius: 4px 0 0 4px;
        }
        &:last-child {
            border-radius: 0 4px 4px 0;
        }
    `,
};

stepperStyles.stepClickableWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: -22px;
        &:hover {
            ${TypographyStyle} {
                :first-child {
                    background-color: ${color("common.ui8")};
                }
                &:nth-child(2n) {
                    color: ${color("common.ui8")};
                }
            }
        }
    `,
};

stepperStyles.stepNumber = {
    weight: fontConfig.weight.bold,
    css: css`
        width: 40px;
        height: 40px;
        border-radius: 20px;
        line-height: 40px;
        text-align: center;
        vertical-align: middle;
        &.active,
        &.complete {
            background-color: ${color("primary.main")};
            border: 1px solid ${color("common.ui1")};
            color: ${color("common.ui1")};
        }
        &.incomplete {
            background-color: ${color("common.ui1")};
            border: 1px solid ${color("primary.main")};
            color: ${color("primary.main")};
        }
    `,
};

stepperStyles.stepName = {
    weight: fontConfig.weight.bold,
    color: "text.link",
};
